enum EBuyersParticipantsPromotion {
  ONLY_NEW_BUYERS = 'only_new_buyers',
  ONLY_CURREN_BUYERS = 'only_curren_buyers',
  ALL_BUYERS = 'all_buyers',
}

export default EBuyersParticipantsPromotion;
